// Copyright (c) 2024 Deere & Company

import actions from '../../actions-list';

export const updateAmountOfUseRequestListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_FILTER_BY
});

export const updateAmountOfUseRequestListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_SORT_BY
});

export const updateAmountOfUseRequestListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/amount-of-use-request-search-filters.js